/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { PDFExport } from "@progress/kendo-react-pdf";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import Layout from "components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
} from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import { useGetCashCenters, useGetCustomers } from "utils/apis/lookups.api";
import { format, formatDate } from "date-fns";
import { isOperationAllowed, showToast } from "utils/helper";
import { useGetReportsCITServices } from "utils/apis/reports.api";
import { Loader } from "@progress/kendo-react-indicators";
import CitServicesReportSlip from "./citServicesReportGrid";
import { Permissions } from "utils/enums";

const serviceTypes = [
  {
    label: "B2B Service",
    value: "B2B Service",
  },
  {
    label: "Collection",
    value: "Collection",
  },
  {
    label: "Delivery",
    value: "Delivery",
  },
  {
    label: "Vault Holding",
    value: "Vault Holding",
  },
];

const currentDate = new Date();

function CitServicesReport() {
  const user = useContext(UserContext);

  const [reportData, setReportData] = useState<any>([]);

  const [ddlServiceTypes, setDdlServiceTypes] = useState("");

  const [ddlCashCenters, setDdlCashCenters] = useState("");

  const [ddlCustomers, setDdlCustomers] = useState("");

  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(currentDate);
  const [reportName, setReportName] = useState("");

  const [loaderPanel, setLoaderPanel] = useState("hidden");
  const [disableDdlServiceType, setDisableDdlServiceType] = useState(false);
  const [disableDdlCc, setDisableDdlCc] = useState(false);
  const [disableDdlCustomers, setDisableDdlCustomers] = useState(false);
  const [disableTxtFromDate, setDisableTxtFromDate] = useState(false);
  const [disableTxtToDate, setDisableTxtToDate] = useState(false);

  const pdfExportComponent = useRef<any>(null);

  const excelExporter = useRef<any>(null);

  const { data: cashCenters } = useGetCashCenters();
  const { data: customers } = useGetCustomers();

  // function disableControls() {
  //   setDisableDdlServiceType(true);
  //   setDisableDdlCc(true);
  //   setDisableDdlCustomers(true);
  //   setDisableTxtFromDate(true);
  //   setDisableTxtToDate(true);
  //   setLoaderPanel("d-block");
  // }

  function enableControls() {
    setDisableDdlServiceType(false);
    setDisableDdlCc(false);
    setDisableDdlCustomers(false);
    setDisableTxtFromDate(false);
    setDisableTxtToDate(false);
    setLoaderPanel("hidden");
  }

  const {
    data: citServicesData,
    mutate: generateReportRequest,
    error,
    isPending,
  } = useGetReportsCITServices();

  useEffect(() => {
    if (citServicesData) {
      const services: any = [];

      citServicesData?.forEach((req: any) => {
        let collectionTeamLeader = "";
        let collectionDriver = "";
        let collectionGuard1 = "";
        let collectionGuard2 = "";

        let deliveryTeamLeader = "";
        let deliveryDriver = "";
        let deliveryGuard1 = "";
        let deliveryGuard2 = "";

        if (req?.collectionTeam && req?.collectionTeam?.length > 0) {
          const ctlObj = req?.collectionTeam.find(
            (ft: any) => ft.role === "Team Leader"
          );

          if (ctlObj)
            collectionTeamLeader = `${ctlObj.name} (${ctlObj.employeeId})-${ctlObj.nationality}`;

          const driverObj = req?.collectionTeam.find(
            (ft: any) => ft.role === "Driver"
          );

          if (driverObj)
            collectionDriver = `${driverObj.name} (${driverObj.employeeId})-${driverObj.nationality}`;

          const guards = req?.collectionTeam.filter(
            (ft: any) => ft.role === "Guard"
          );

          if (guards.length > 1) {
            collectionGuard1 = `${guards[0].name} (${guards[0].employeeId})-${guards[0].nationality}`;

            collectionGuard2 = `${guards[1].name} (${guards[1].employeeId})-${guards[1].nationality}`;
          } else {
            collectionGuard1 = `${guards[0].name} (${guards[0].employeeId})-${guards[0].nationality}`;
          }
        }

        if (req?.deliveryTeam && req?.deliveryTeam?.length > 0) {
          const ctlObj = req?.deliveryTeam.find(
            (ft: any) => ft.role === "Team Leader"
          );

          if (ctlObj)
            deliveryTeamLeader = `${ctlObj.name} (${ctlObj.employeeId})-${ctlObj.nationality}`;

          const driverObj = req?.deliveryTeam.find(
            (ft: any) => ft.role === "Driver"
          );

          if (driverObj)
            deliveryDriver = `${driverObj.name} (${driverObj.employeeId})-${driverObj.nationality}`;

          const guards = req?.deliveryTeam.filter(
            (ft: any) => ft.role === "Guard"
          );

          if (guards.length > 1) {
            deliveryGuard1 = `${guards[0].name} (${guards[0].employeeId})-${guards[0].nationality}`;

            deliveryGuard2 = `${guards[1].name} (${guards[1].employeeId})-${guards[1].nationality}`;
          } else {
            deliveryGuard1 = `${guards[0].name} (${guards[0].employeeId})-${guards[0].nationality}`;
          }
        }

        const service = {
          ...req,
          collectionTeamLeader,
          collectionDriver,
          collectionGuard1,
          collectionGuard2,
          deliveryTeamLeader,
          deliveryDriver,
          deliveryGuard1,
          deliveryGuard2,
        };

        services.push(service);
      });

      setReportData(services);
      enableControls();
    }
    if (error?.message) {
      setReportData([]);
      setLoaderPanel("hidden");
      enableControls();
      showToast("error", "On selected date range report not found.");
    }
  }, [citServicesData, error]);

  const generateReport = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    let stype = null;
    if (ddlServiceTypes) stype = ddlServiceTypes;

    let customerId = null;

    if (ddlCustomers) customerId = ddlCustomers;

    const cashCenterId = ddlCashCenters;

    const reportParams = {
      serviceType: stype,
      customerId,
      cashCenterId,
      fromDate: formatDate(
        fromDate || currentDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      toDate: formatDate(toDate || currentDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
    };

    generateReportRequest(reportParams);
    setLoaderPanel("block");

    const repName = `CIT_Services_Report_from_${format(fromDate || currentDate, "dd-MMM-yyyy")}_to_${format(toDate || currentDate, "dd-MMM-yyyy")}`;

    setReportName(repName);
  };

  const exportToExcel = () => {
    if (excelExporter.current) {
      const options = excelExporter.current.workbookOptions();
      const rows = options.sheets[0].rows;

      const cellOptions = { bold: true, borderBottom: true };
      rows.unshift(
        {
          type: "data",
          cells: [
            {
              value: `Company Name: ${process.env.REACT_APP_CLIENT === "CT" ? "Cashtrans" : "FHK"}`,
              ...cellOptions,
            },
          ],
        },
        {
          type: "data",
          cells: [
            { value: "Report Name: CIT Services Report", ...cellOptions },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Generated Date: ${formatDate(new Date(), "E MMM dd hh:mm a  yyyy")}`,
              ...cellOptions,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `Generated By: ${user.UserName}-${user.DisplayName}`,
              ...cellOptions,
            },
          ],
        },
        {
          type: "data",
          cells: [
            {
              value: `From Date: ${format(fromDate || currentDate, "dd-MMM-yyyy")},  To Date: ${format(toDate || currentDate, "dd-MMM-yyyy")}`,
              ...cellOptions,
            },
          ],
        }
      );
      options.sheets[0].freezePane.rowSplit = 6;

      excelExporter.current.save(options);
    }
  };

  const exportToPDF = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Reports</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>CIT Services Report</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCc}
                  placeholder="Select Cash center"
                  value={ddlCashCenters}
                  data={cashCenters?.map((item) => ({
                    value: item?.cashCenterId,
                    label: item?.name,
                  }))}
                  setValue={setDdlCashCenters}
                />
              </div>

              <div className="flex-1">
                <Combobox
                  disabled={disableDdlServiceType}
                  value={ddlServiceTypes}
                  data={serviceTypes}
                  placeholder="Select Service"
                  setValue={setDdlServiceTypes}
                />
              </div>

              <div className="flex-1">
                <Combobox
                  disabled={disableDdlCustomers}
                  value={ddlCustomers}
                  data={customers?.map((item) => ({
                    label: item?.name,
                    value: item?.customerId,
                  }))}
                  placeholder="Select Customer"
                  setValue={setDdlCustomers}
                />
              </div>
              <div className="flex-1">
                <DatePicker
                  disabled={disableTxtFromDate}
                  placeholder="Select From Date"
                  selectedDate={fromDate}
                  onSelectDate={setFromDate}
                />
              </div>
              <div className="flex-1">
                <DatePicker
                  disabled={disableTxtToDate}
                  placeholder="Select To Date"
                  selectedDate={toDate}
                  onSelectDate={setToDate}
                />
              </div>
              <div className="flex gap-3">
                <Button
                  variant="secondary"
                  onClick={generateReport}
                  isLoading={isPending}
                >
                  Get Report
                </Button>
                {isOperationAllowed(
                  Permissions.Report,
                  Permissions.PdfExport
                ) ? (
                  <Button variant="secondary" onClick={exportToPDF}>
                    <svg
                      viewBox="0 0 512 512"
                      fill="currentColor"
                      className="w-6"
                    >
                      <path d="M240.9 160c-7.6 0-13.8 4-15.4 9.9-4.9 18.6.2 46.3 9.4 82.3l-2.4 5.9c-6.6 16.4-14.8 33-22.1 47.6l-1 1.9c-7.7 15.3-14.6 28.4-21 39.4l-6.5 3.5c-.5.3-11.6 6.3-14.3 7.9-22.2 13.6-36.9 28.9-39.4 41.2-.8 3.9-.2 8.9 3.7 11.2l6.3 3.2c2.7 1.4 5.6 2.1 8.6 2.1 15.8 0 34.2-20.2 59.5-65.3 29.2-9.7 62.5-17.8 91.6-22.3 22.2 12.8 49.5 21.7 66.8 21.7q4.65 0 7.8-.9c3.3-.9 6.1-2.8 7.8-5.4 3.4-5.2 4-12.2 3.1-19.5-.3-2.1-2-4.8-3.8-6.6-5.1-5.2-16.5-7.9-33.7-8.1-11.7-.1-25.8.9-40.6 3-6.6-3.9-13.5-8.2-18.8-13.3-14.4-13.8-26.5-32.9-34-53.9.5-2 .9-3.7 1.3-5.4 0 0 8.1-47.1 6-63.1-.3-2.2-.5-2.8-1.1-4.5l-.7-1.9c-2.2-5.2-6.5-10.7-13.3-10.4zm2.7 8.4c5.1 0 8 13.1 8.2 25.4.3 12.3-2.6 20.9-6 27.3-2.9-9.4-4.3-24.3-4.3-34-.1-.1-.3-18.7 2.1-18.7m.4 104.1c8.6 16 19.3 29.5 31.9 40.4 1.6 1.3 3.2 2.7 5 4.1-25.6 5.2-47.7 11.5-67.1 19.1 3.6-6.5 7.2-13.3 11-20.6 9.1-17.7 14.9-31.6 19.2-43m102.2 51.6c9.3 0 12 0 21.1 2.3 9.1 2.4 9.2 7.2 7.6 8.2s-6 1.6-8.9 1.6c-9.2 0-20.7-4.3-36.8-11.4 6.3-.4 11.9-.7 17-.7m-165.4 35.8c-17.7 28.8-29.5 40.3-37.3 43.8 2.9-8.1 14.3-24 31.2-38.1 1.1-.9 3.7-3.4 6.1-5.7M352 32H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                    </svg>
                  </Button>
                ) : null}
                {isOperationAllowed(
                  Permissions.Report,
                  Permissions.ExcelExport
                ) ? (
                  <Button variant="secondary" onClick={exportToExcel}>
                    <svg
                      viewBox="0 0 512 512"
                      fill="currentColor"
                      className="w-6"
                    >
                      <path d="m288 304 64 112h-48l-48-84.5-31.5 52.5H256v32h-96l64-112-64-112h48l48 84 48-84h48zm64-272H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128zm64 416H96V64h224v96h96z" />
                    </svg>
                  </Button>
                ) : null}
              </div>
            </div>
            <div className="border-b my-3 bg-accent" />
            <div className={`text-center ${loaderPanel}`}>
              <Loader size="large" type="converging-spinner" />
            </div>
            <PDFExport
              scale={0.4}
              ref={pdfExportComponent}
              paperSize="A4"
              landscape
              fileName={reportName}
            >
              <div className="flex report-template">
                <div className="flex-1">
                  <span className="text-primary-darken-3 h6">
                    Company Name:{" "}
                    {process.env.REACT_APP_CLIENT === "CT"
                      ? "Cashtrans"
                      : "FHK"}
                  </span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">
                    Report Name: CIT Services Report
                  </span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">
                    Generated Date:
                    <LiveClock />
                  </span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">{`Generated By: ${user.UserName}-${user.DisplayName}`}</span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                  <span className="text-primary-darken-3 h6">
                    {`From Date: ${format(fromDate || currentDate, "dd-MMM-yyyy")},  To Date: ${format(toDate || currentDate, "dd-MMM-yyyy")}`}
                  </span>
                  <div className="border-bottom mt-2 mb-2 bg-accent-4" />
                </div>

                <div className="flex-1 text-center" />

                <div className="flex-1 text-start" />
              </div>
              <div className="mt-3">
                {reportData.length ? (
                  <CitServicesReportSlip reportData={reportData} />
                ) : null}
              </div>
            </PDFExport>

            <ExcelExport
              data={reportData}
              collapsible
              fileName={reportName}
              ref={excelExporter}
            >
              <ExcelExportColumn field="customer" title="Customer" />
              <ExcelExportColumn field="city" title="Emirates" />
              <ExcelExportColumn field="serviceDate" title="Job Date" />
              <ExcelExportColumn field="startDate" title="Start Time" />
              <ExcelExportColumn
                field="completionDate"
                title="Completion Time"
              />
              <ExcelExportColumn field="jobNature" title="Job Type" />
              <ExcelExportColumn field="sourceLocation" title="From Location" />
              <ExcelExportColumn
                field="interimLocations"
                title="Interim Locations"
              />
              <ExcelExportColumn
                field="onwardLocation"
                title="Final Location"
              />
              <ExcelExportColumn field="commodityType" title="Commodity Type" />
              <ExcelExportColumn field="requestId" title="Order Id" />
              <ExcelExportColumn field="serviceType" title="Service Type" />
              <ExcelExportColumn field="invoicingModel" title="Invoice Type" />
              <ExcelExportColumn field="status" title="Status" />
              <ExcelExportColumn field="orderValue" title="Order Value" />
              <ExcelExportColumn field="containers" title="Containers" />
              <ExcelExportColumn
                field="collectionRouteNo"
                title="Collection Route No"
              />
              <ExcelExportColumn field="collectionTeamLeader" title="Crew1" />
              <ExcelExportColumn field="collectionGuard1" title="Crew2" />
              <ExcelExportColumn field="collectionGuard2" title="Crew3" />
              <ExcelExportColumn field="collectionDriver" title="Driver" />
              <ExcelExportColumn
                field="deliveryRouteNo"
                title="Delivery Route No"
              />
              <ExcelExportColumn field="deliveryTeamLeader" title="Crew1" />
              <ExcelExportColumn field="deliveryGuard1" title="Crew2" />
              <ExcelExportColumn field="deliveryGuard2" title="Crew3" />
              <ExcelExportColumn field="deliveryDriver" title="Driver" />
            </ExcelExport>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}
function getCurrentTime() {
  return formatDate(new Date(), "E MMM dd hh:mm a  yyyy");
}

function LiveClock() {
  const [currentTime, setCurrentTime] = useState(getCurrentTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(getCurrentTime());
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return <>{currentTime}</>;
}
export default CitServicesReport;
